import { Component, OnInit } from '@angular/core';
import { GlobalConfig } from '../../entities/global-config';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-conform-message',
  templateUrl: './conform-message.component.html',
  styleUrls: ['./conform-message.component.css']
})
export class ConformMessageComponent implements OnInit {
  subject: Subject<boolean>;
  confirmationMessage: any = '';
  isPrimary: any = false;

  constructor(
    private global: GlobalConfig,
  ) {

  }

  ngOnInit() {
    this.confirmationMessage = this.global.confirmService.confirmMessage;
    if (this.global.modelServiceData) {
      this.isPrimary = this.global.modelServiceData.isPrimary;
      this.global.modelServiceData = '';
    }
    this.global.confirmService = { confirmMessage: '' };
  }

  conformMessge(confirm: boolean) {
    this.subject.next(confirm);
    this.subject.complete();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/conform-message/conform-message/conform-message.component.ts